<template>
  <div>

    <div class="arautos-header">
      <center>
        <b-img fluid src="https://cdnarautos.s3.amazonaws.com/2020/08/Logos_Capa_Arautos_WEB3.png" alt="Image 1"></b-img>
      </center>

      <div class="linha-menu"></div>
    </div>

    <b-container v-show="alertSucesso">
      <b-media right-align vertical-align="center">
        <template #aside>
          <b-img fluid src="https://cdnarautos.s3.amazonaws.com/sites/21/2020/11/img-revista-02.png" alt="Image 1"></b-img>
        </template>
        <p class="mt-4">&nbsp;</p>
        <h4 class="mt-5 mb-2">Sua resposta foi enviada com sucesso!</h4>
        <p class="mt-4 mb-2">
          Clique no link e acesse o exemplar Digital da Revista Arautos do Evangelho:
        </p>
        <p><a href="https://revistacatolica.com.br/">https://revistacatolica.com.br/</a></p>
      </b-media>
    </b-container>

    <b-container v-show="alertError">
      <b-media right-align vertical-align="center">
        <template #aside>
          <b-img fluid src="https://cdnarautos.s3.amazonaws.com/sites/21/2020/11/img-revista-02.png" alt="Image 1"></b-img>
        </template>
        <p class="mt-4">&nbsp;</p>
        <h4 class="mt-5 mb-2">{{ error.message }}</h4>
        <p class="mt-4 mb-2">
          Clique no link e acesse o exemplar Digital da Revista Arautos do Evangelho:
        </p>
        <p><a href="https://revistacatolica.com.br/">https://revistacatolica.com.br/</a></p>
      </b-media>
    </b-container>

    <b-container class="bv-example-row" v-show="!loading && hasData">
      <p>{{ user.tratamentoDisplay }}<b> {{ user.nomeDisplay }}</b></p>

      <p>Salve Maria!</p>

      <p>
        Nesta página estão disponíveis as opções relativas à sua colaboração <b>{{ user.mesDisplay }}</b>
      </p>

      <p>
        Por favor, indique-nos uma opção para que possamos registrar em nossos sistemas:
      </p>

      <div class="form-group">
        <el-radio-group v-model="optionSelected">
          <template v-for="(option, i) in tabulacoes">
            <el-radio :key="i" :label="option" border>{{ option.tabulacao }}</el-radio>
          </template>
        </el-radio-group>
      </div>

      <p>
        Se tiver mais informações, utilize o campo de observações para enviar-nos uma mensagem.
      </p>
      <p>
        <b-form-textarea v-model="obs" placeholder="Observação"></b-form-textarea>
      </p>
      <b-btn @click.prevent="confirm" variant="success">Confirmar</b-btn>

      <p style="font-size:0.8em; margin-top: 15px">
        <center>
        Para a sua segurança, todas os dados cadastrais não são alterados nesta página. Caso precise mudar alguma informação no seu cadastro, por favor entre em contato conosco.
        </center>
      </p>
    </b-container>

    <div class="linha-menu"></div>

    <b-container>

      <table cellspacing="0" cellpadding="0" align="center" valign="middle">
        <tbody>
          <tr>
            <td>
              <table width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                  <tr style="background-color: #ffffff">
                    <td align="center" valign="middle">
                      <h3 style="font-family: Arial, Helvetica, sans-serif;color: #192f19;padding-right: 10px;">
                        Fale conosco
                      </h3>
                      <table width="100%" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr style="background-color: #ffffff" width="123">
                            <td align="center" valign="middle">
                              <table width="70%" cellspacing="0" cellpadding="0">
                                <tbody>
                                  <tr style="background-color: #ffffff">
                                    <td align="center" valign="middle" style="padding-bottom: 10px">
                                      <img style="display: block" src="https://cdnarautos.s3.us-east-1.amazonaws.com/social-logos/phone_PNG48992.png" alt="Ligue para o Atendimento ao Assinante" width="33" height="33"/>
                                    </td>
                                    <td>
                                      <span style="padding-left: 10px;color: #192f19;">(11) 2971-9050</span>
                                    </td>
                                  </tr>
                                  <tr style="background-color: #ffffff">
                                    <td align="center" valign="middle">
                                      <img style="display: block" src="https://cdnarautos.s3.us-east-1.amazonaws.com/social-logos/email-icon-png-email-icon-image-122-2400.png" alt="Mande um e-mail para o Atendimento ao Assinante" width="33" height="33"/>
                                    </td>
                                    <td>
                                      <span style="padding-left: 10px;color: #192f19;">admrevista@arautos.org.br</span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td align="center" valign="middle">
                      <h3 style="font-family: Arial, Helvetica, sans-serif; color: #192f19;">
                        Mantenha-se conectado
                      </h3>
                      <table width="100%" cellspacing="0" cellpadding="0">
                        <tbody>
                          <tr style="background-color: #ffffff" width="123">
                            <td align="center" valign="middle">
                              <a href="https://revistacatolica.com.br/" target="_blank" title="Revista Arautos do Evangelho" style="display: block">
                                <img style="display: block" src="https://cdnarautos.s3.amazonaws.com/2020/04/logo-em-baixo.png" alt="Revista Arautos do Evangelho" width="63" height="100%"/>
                              </a>
                            </td>
                            <td align="center" valign="middle" style="padding-right: 20px">
                              <a href="https://www.youtube.com/user/TVArautos" target="_blank" title="Inscreva-se no canal" style="display: block">
                                <img style="display: block" src="https://cdnarautos.s3.us-east-1.amazonaws.com/social-logos/youtube_social_icon_red.png" alt="Inscreva-se no canal" width="43" height="100%"/>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr style="background-color: #ffffff">
            <td>&nbsp;</td>
          </tr>
          <tr style="background-color: #ffffff">
            <td align="left" valign="top">
              <table width="100%" cellspacing="0" cellpadding="0">
                <tbody>
                  <tr>
                    <td align="left" valign="middle">
                      <p
                        style="font-family: Arial, Helvetica, sans-serif;padding-left: 10px;padding-right: 10px;color: #1f1317;font-size: 14px;">
                        <strong>Administração: </strong>Rua Diogo de Brito, 41 - 02460-110 - São Paulo - SP <br /><strong>Atendimento ao assinante: </strong>nos dias úteis, de 8 às 17:00h
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">
                      <p style=" font-family: Arial, Helvetica, sans-serif; padding-left: 10px; padding-right: 10px; color: #1f1317; font-size: 12px;">
                        Copyright&copy; Revista Arautos do Evangelho 2021. Todos
                        os direitos reservados. Divulgação autorizada, citando a
                        fonte.
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td align="left" valign="middle">
                      <p style=" font-family: Arial, Helvetica, sans-serif; padding-left: 10px; padding-right: 10px; color: #1f1317; font-size: 12px;">
                        Importante: Se não quiser receber nossas mensagens,
                        <a href="https://revistacatolica.com.br/remover-email/" target="_blank" title="Instruções Anti-Span" style="color: #22009d">clique aqui</a>
                        para para descadastrar seu e-mail.
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

    </b-container>

    <b-modal id="modal-center" hide-backdrop content-class="shadow" centered hide-header ok-only ok-title="Aceitar" no-close-on-esc no-close-on-backdrop ok-variant="dark">
      <p class="my-4" >Utilizamos cookies em nosso site para oferecer uma experiência mais relevante ao lembrar suas preferências. Ao clicar em "Aceitar", você concorda com o uso de todos os cookies. <a href="https://revistacatolica.com.br/politica-cookies/" target="_blank" >Leia mais</a></p>
    </b-modal>

    <b-modal id="modal-center-error" hide-backdrop content-class="shadow" centered :title="error.title" ok-only hide-header ok-variant="dark">
      <p class="my-4">{{ error.message }}</p>
    </b-modal>

    <b-modal id="modal-center-loading" hide-backdrop content-class="shadow" centered ok-only hide-footer hide-header no-close-on-esc no-close-on-backdrop ok-variant="dark">
      <p class="my-4" v-loading="true">.</p>
    </b-modal>

  </div>
</template>

<script>
import { retencaoOnline } from "../../../service";

export default {
  name: "RetencaoOnline",

  data() {
    return {
      query: { auth: "", client: "" },
      user: {},
      tabulacoes: [],

      optionSelected: {},
      obs: "",
      loading: true,

      cookieHasAccepted: false,
      hasData: false,

      error: {},
      alertSucesso: false,
      alertError: false
    };
  },

  mounted() {
    let query = this.$route.query;

    try {
      if (!query.auth || !query.client) throw Error("Params query not found");

      this.showLoading(true)

      return this.find(query.client, query.auth)
    } catch (e) {
      console.log(e.message);
    }

    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      console.log('Modal is about to be shown', bvEvent, modalId)
    })

  },

  methods: {

    showLoading(show = true){
      if(show){
        this.$root.$emit('bv::show::modal', 'modal-center-loading', '#btnShow')
      } else {
        this.$root.$emit('bv::hide::modal', 'modal-center-loading', '#btnShow')
      }
    },

    find(client, auth) {
      return retencaoOnline
        .fetch({ client, auth })
        .then(({ user, tabulacoes }) => {
          if(!user) throw Error("Link acesso não existe ou já está expirado.")

          this.loading = false
          this.showLoading(this.loading)

          this.hasData = true
          this.user = user
          this.tabulacoes = tabulacoes

          if(!this.cookieHasAccepted){
            this.$root.$emit('bv::show::modal', 'modal-center', '#btnShow')
            this.cookieHasAccepted = true
          }

        })
        .catch((e) => {
          this.loading = false
          this.alertError = true
          this.showLoading(this.loading)

          this.error = { title: "Erro", message: e.message || e }

          this.loading = false
          // window.location.href = "https://revistacatolica.com.br/"
        })
    },

    confirm() {
      try {
        if (!this.optionSelected.id) throw Error("Por favor, escolha uma das opções.");


        this.showLoading(true)

        let tabulacao = {
          tabulacao: this.optionSelected.id,
          tabulacaoMotivo: this.optionSelected.motivoId,
          obs: this.obs || ""
        };

        let query = this.$route.query;

        retencaoOnline
          .save({ client: query.client, auth: query.auth, tabulacao })
          .then(() => {
            this.showLoading(false)
            this.alertSucesso = true
            this.hasData = false
          })
          .catch(console.log)

        console.log(tabulacao);
      } catch (e) {
        this.error = {
          title: "Erro",
          message: e.message
        }

        this.$root.$emit('bv::show::modal', 'modal-center-error', '#btnShow')

      }
    },
  }
};
</script>

<style scoped>

* {
  font-family: 'Open Sans', 'Open Sans Regular', sans-serif;
}

.arautos-header {
  background-image: url("https://s3.amazonaws.com/cdnarautos/2020/04/bk4.jpg");
  background-repeat: repeat;
  padding-top: 20px;
}

.linha-menu {
  background-color: #192f19;
  height: 32px;
  margin-bottom: 30px;
  margin-top: 20px;
}

.el-radio.is-bordered {
  display: block;
  margin-left: 0 !important;
}

</style>


// WEBPACK FOOTER //
// RetencaoOnline.vue?7340a4f8